module.exports = __webpack_public_path__ + "img/superiority1.1f41602.png";